<div class="p-4 fx-row x-center">
  <div class="fx-column fx-0-1" [style.maxWidth]="'810px'" [style.width]="'810px'">
    <h1 id="select-photographer-header">Please select your photographer</h1>
    @if (cardOptions$ | async; as options) {
      @if (loadError()) {
        <div role="alert">
          <p>We couldn't load photographers. Please try again.</p>
          <button mat-stroked-button type="button" (click)="retry()">Try again</button>
        </div>
      } @else if (!options.length) {
        <p>No photographers are assigned to your account.</p>
      } @else {
        <lc-card-options valuePath="id" [options]="options" (selected)="onSelected($event)" />
        <div class="fx-row">
          <button color="primary" id="next-button" lcTestId="next-button" mat-raised-button type="button" [disabled]="!selectedPhotographer" (click)="onSubmit()">Next</button>
        </div>
      }
    }
  </div>
</div>
